'use client';

import Link from 'next/link';
import { useCallback, useState } from 'react';
import { useTranslations } from 'next-intl';

export default function Footer() {
  const t = useTranslations('topbar');
  const tFooter = useTranslations('footer');
  const [copiedNumber, setCopiedNumber] = useState(false);
  const [copiedEmail, setCopiedEmail] = useState(false);

  const FOOTER_ITEMS = [
    { key: "productCatalog", sectionId: "product-catalog" },
    { key: "ourMission", sectionId: "our-mission-section" },
    { key: "aboutUs", sectionId: "about-us-section" },
    { key: "ourVision", sectionId: "our-vision-section" },
    { key: "contactUs", sectionId: "footer" },
  ];

  const scrollTo = useCallback((sectionId: string) => {
    let top = 0;
    if (sectionId === "footer") {
      const target = document.querySelector("footer") || document.getElementById("footer");
      if (target) {
        top = target.getBoundingClientRect().top + window.scrollY;
      } else {
        top = document.documentElement.scrollHeight - window.innerHeight;
      }
    } else {
      const target = document.getElementById(sectionId);
      if (!target) return;
      const navbarHeight = 82;
      top = target.getBoundingClientRect().top + window.scrollY - navbarHeight;
    }
    window.scrollTo({ top, behavior: "smooth" });
  }, []);

  const handleEmailClick = useCallback(async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const email = "vyasenterprises3636@gmail.com";

    try {
      await navigator.clipboard.writeText(email);
      setCopiedEmail(true);
      setTimeout(() => setCopiedEmail(false), 2000);
    } catch {
      console.error("Failed to copy email");
    }
  }, []);

  const handlePhoneClick = useCallback(
    async (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();

      const phone = "+919111113844";

      try {
        await navigator.clipboard.writeText(phone);
        setCopiedNumber(true);
        setTimeout(() => setCopiedNumber(false), 2000);
      } catch {
        console.error("Failed to copy phone number");
      }
    },
    []
  );

  return (
    <div className="w-full bg-[#0F172A] px-6 py-8 sm:px-8">

      <div className="footer-top-section flex flex-col items-center md:flex-row md:justify-between md:items-start gap-8 mb-8 sm:px-12">

        <Link href="/" className="flex md:flex-col justify-center items-center gap-2 md:gap-4 shrink-0">
          <img src="/logo/circular_logo.svg" alt="AgarMart Logo" className="h-14 md:h-16" />
          <img src="/logo/text_logo.svg" alt="AgarMart Logo Text" className="h-6 md:h-8" />
        </Link>

        <div className="footer-nav-contact-row flex flex-col items-center md:flex-row gap-8 w-full justify-center">
          <div className="footer-links flex flex-1 justify-center items-center">
            <div className="grid grid-cols-2 gap-x-8 gap-y-3">
              {FOOTER_ITEMS.map(({ key, sectionId }) => (
                <button
                  key={key}
                  type="button"
                  onClick={() => scrollTo(sectionId)}
                  className="text-white text-lg font-medium text-left hover:text-blue-300 transition-colors duration-150 cursor-pointer bg-transparent border-none p-0"
                >
                  {t(key as Parameters<typeof t>[0])}
                </button>
              ))}
            </div>
          </div>


          <div className="footer-contact flex flex-col items-center sm:items-start justify-center gap-2">
            <h2 className="text-3xl font-semibold text-gray-200 mb-1">{tFooter('team')}</h2>

            <a
              href="mailto:vyasenterprises3636@gmail.com"
              onClick={handleEmailClick}
              className="flex items-center gap-2 group"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#2563eb" className="w-5 h-5 shrink-0">
                <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
              </svg>
              <span className="text-blue-400 font-medium group-hover:text-blue-300 transition-colors duration-150">vyasenterprises3636@gmail.com</span>
            </a>

            <a
              href="#"
              onClick={handlePhoneClick}
              className="flex items-center gap-2 group cursor-pointer"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#2563eb" className="w-5 h-5 shrink-0">
                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
              </svg>
              <span className="text-blue-400 font-medium group-hover:text-blue-300 transition-colors duration-150">+91 9111113844</span>
            </a>

            <a
              href="https://maps.google.com/?q=10-ts+lohamandi+Agarsen+Square+Indore+Madhya+Pradesh"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start gap-2 group"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#2563eb" className="w-5 h-5 shrink-0 mt-0.5">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
              </svg>
              <span className="text-blue-400 font-medium text-center sm:text-left group-hover:text-blue-300 transition-colors duration-150">
                10-ts lohamandi, Agarsen Square,<br />Indore, Madhya Pradesh
              </span>
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-slate-700 pt-4 flex justify-center">
        <p className="text-sm text-[#CBD5E0]">
          © {new Date().getFullYear()} AgarMart Trading Co. All rights reserved.
        </p>
      </div>
      {copiedNumber && (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 rounded-lg bg-green-600 px-4 py-2 text-white shadow-lg z-50">
          Phone number copied to clipboard!
        </div>
      )}
      {copiedEmail && (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 rounded-lg bg-green-600 px-4 py-2 text-white shadow-lg z-50">
          Email copied to clipboard!
        </div>
      )}

    </div>
  );
}